module.exports = __webpack_public_path__ + "img/shopping-bag-white.6a552ac8.svg";